import React from 'react';
import { 
    Button, 
    GridList, GridListTile, GridListTileBar, 
    IconButton, 
    Tooltip, 
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import {withStyles} from '@material-ui/core/styles';
import styles from "./FileList.css";
import CellSizeController from './CellSizeController';

function FileList(props) {
    
    const {classes, files, editable, removeFileFromList, clearFilesList, cellSize, changeCellSize} = props;

    return (
        <div className={classes.fileList}>
            <Tooltip title="Discard images">
                <Button 
                    className={classes.clearButton} 
                    color="secondary"
                    onClick={clearFilesList}
                    disabled={!editable}
                >
                    <DeleteForeverIcon />
                </Button>
            </Tooltip>

            <div className={classes.preview}>
                <GridList className={classes.gridList} cols={5.5}>
                    {
                        files.map( (file, index) => {

                            let fileExt =  file.name.slice((file.name.lastIndexOf(".") - 1 >>> 0) + 2);

                            let filePreview;
                            let tooltipMessage = '';

                            if (fileExt.toLowerCase() === 'tif') {
                                filePreview = process.env.PUBLIC_URL + '/images/tif-placeholder.png';
                                tooltipMessage = ' (we cannot display TIF images)';
                            } else if (fileExt.toLowerCase() === 'tiff') {
                                filePreview = process.env.PUBLIC_URL + '/images/tiff-placeholder.png';
                                tooltipMessage = ' (we cannot display TIFF images)';
                            } else {
                                filePreview = file.preview;
                            }
                            return (
                                <Tooltip title={file.name + tooltipMessage} placement="top" key={index}> 
                                    <GridListTile key={index} classes={{root: classes.imageTile}}>
                                        <img src={filePreview} alt={file.name} className={classes.previewImage} />
                                        <GridListTileBar
                                            classes={{root: classes.titleBar}}
                                            actionIcon = {
                                                <IconButton 
                                                    onClick={() => removeFileFromList(file.name)}
                                                    color="secondary"
                                                    className={classes.deleteButton}
                                                    disabled={!editable}
                                                >
                                                    <DeleteIcon />
                                                </IconButton>
                                            }
                                        />
                                    </GridListTile>
                                </Tooltip>
                            )
                    })
                }
                </GridList>
 
                <CellSizeController cellSize={cellSize} changeCellSize={changeCellSize}/>
            </div>
        </div>
    );
}

export default withStyles(styles, {withTheme: true})(FileList);
